import React from 'react';
import { Row, Col } from 'antd'; // Feltételezem, hogy az antd könyvtárat használod
import './Logo.css'; // Stíluslap importálása

const AppContainer = ({ children, heading }) => {
    const loginBoxStyle = {
        backgroundColor: '#fff', // Háttérszín beállítása itt
        padding: '30px', // További stílusok...
        borderRadius: '5px',
        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
      };

  return (
    <div className="app-container">
      <Row justify="center" align="middle" style={{ minHeight: '100vh' }}>
        <Col xs={24} sm={12} md={8} lg={6} xl={6}>
          <div style={loginBoxStyle} className="login-box">
            <div className="logo"></div>
            <Row justify="center">
              <Col>
                <h1 className="login-heading">{heading}</h1>
              </Col>
            </Row>
            {children} 
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AppContainer;
